export enum WizardStepState {
  unknown,
  inactive,
  active,
  completed,
  general,
}
